import React, { useState, useEffect } from "react";
import { useParams,Link } from 'react-router-dom';
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import PopupChildrenStudy from "../../../components/popups/PopupChildrenStudy";
import {SetBasePageStatus,ChangeDateString,GetAdminAttendanceStatus} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

export const CourseDetail = () => {
  let { cl_idx } = useParams();

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //선택 수강 정보
  const [varCourseInfo,setCourseInfo] = useState({});
  //수강현황
  const [varStudyList,setStudyList] = useState([]);


  //클래스 정보 호출
  const GetCourseInformation = async() => {
    const sendData = {cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_course_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //수강정보
        setCourseInfo(datas.results[0]);
        //수강학생
        const childrens = datas.childrens;
        const counters = datas.counters;
        childrens.forEach((child)=>{
          let countData = counters.find(el=>el.csc_ch_idx===child.csc_ch_idx);
          child.pass_cnt = countData.pass_cnt;
          child.tstudys = countData.tstudys;
        });
        console.log(childrens);
        //수강내역
        const studyList = datas.studys;
        for(var i=0; i < studyList.length; i++) {
          let cs_idx = studyList[i].cs_idx;
          //수업별 원생 목록
          let childrenList = childrens.filter(el=>el.cs_idx===cs_idx);
          studyList[i].childrens = childrenList;
        }
        setStudyList(studyList);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'COURSE',item:'Courses'});
    console.log(varAdminMenus);
    GetCourseInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //팝업창
  const [varOpenChildrenStudy, setOpenChildrenStudy] = useState(false);
  const [varChildrenInfo, setChildrenInfo] = useState({});
  const onShowChildrenStudyHandler = (e,ch_idx) => {
    setChildrenInfo({ch_idx:ch_idx,cl_idx:cl_idx});
    SetBasePageStatus(true);
    setOpenChildrenStudy(true);
  }
  //닫기
  const CloseChildrenStudy = () => {
    SetBasePageStatus(false);
    setOpenChildrenStudy(false);
  };

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'수강 관리 상세'} varDirection={'수강 관리 상세'}/>
      <div className="admin-content">
        {/* 수강정보 */}
        <div className="main-box">
          <table className="write">
            <thead>
              <tr>
                <th style={{width:"10%",paddingLeft:"0px",textAlign:"center"}}>센터명</th>
                <th style={{width:"15%",paddingLeft:"0px",textAlign:"center"}}>학기명</th>
                <th style={{width:"8%",paddingLeft:"0px",textAlign:"center"}}>형태</th>
                <th style={{width:"10%",paddingLeft:"0px",textAlign:"center"}}>개강일</th>
                <th style={{width:"10%",paddingLeft:"0px",textAlign:"center"}}>종강일</th>
                <th style={{width:"8%",paddingLeft:"0px",textAlign:"center"}}>차수</th>
                <th style={{width:"20%",paddingLeft:"0px",textAlign:"center"}}>클래스명</th>
                <th style={{width:"8%",paddingLeft:"0px",textAlign:"center"}}>정원</th>
                <th style={{width:"10%",paddingLeft:"0px",textAlign:"center"}}>교실명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{textAlign:"center"}}>{varCourseInfo.bh_company}</td>
                <td style={{textAlign:"center"}}>{varCourseInfo.sm_name}</td>
                <td style={{textAlign:"center"}}>{varCourseInfo.cl_mode===1?"정규":"보강"}</td>
                <td style={{textAlign:"center"}}>{ChangeDateString(varCourseInfo.sm_sdate)}</td>
                <td style={{textAlign:"center"}}>{ChangeDateString(varCourseInfo.sm_edate)}</td>
                <td style={{textAlign:"center"}}>{varCourseInfo.cl_studys}</td>
                <td style={{textAlign:"center"}}>{varCourseInfo.cl_name}</td>
                <td style={{textAlign:"center"}}>{varCourseInfo.cl_childrens}</td>
                <td style={{textAlign:"center"}}>{varCourseInfo.cr_name}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 수강현황 */}
        <div style={{margin:"20px 0px 10px 0px"}}>수강현황</div>
        <div className="main-box">
          <table className="write">
            <thead>
              <tr>
                <th style={{width:"15%",paddingLeft:"0px",textAlign:"center"}}>클래스 차수</th>
                <th style={{width:"30%",paddingLeft:"0px",textAlign:"center"}}>수업일</th>
                <th style={{width:"25%",paddingLeft:"0px",textAlign:"center"}}>원생</th>
                <th style={{width:"10%",paddingLeft:"0px",textAlign:"center"}}>출석</th>
                <th style={{width:"20%",paddingLeft:"0px",textAlign:"center"}}>출석인증</th>
              </tr>
            </thead>
            <tbody>
              {varStudyList.map((studys,i)=>(
                studys.childrens.map((childrens,j)=>(
                  <tr key={'studys_'+i+'_'+j}>
                    {j===0?<td style={{textAlign:"center"}} rowSpan={studys.childrens.length}>{studys.cs_index}차수</td>:null}
                    {j===0?<td style={{textAlign:"center"}} rowSpan={studys.childrens.length}>{ChangeDateString(studys.cs_date)+' '+studys.cs_hour+':'+studys.cs_minute}</td>:null} 
                    <td style={{textAlign:"center",cursor:"pointer",backgroundColor:"#eee"}} onClick={e=>onShowChildrenStudyHandler(e,childrens.ch_idx)}>{childrens.ch_name}</td>
                    <td style={{textAlign:"center"}}>{childrens.pass_cnt+'/'+childrens.tstudys}</td>
                    <td style={{textAlign:"center"}}>{GetAdminAttendanceStatus(childrens.csc_status)}</td>
                  </tr>
                ))
              ))}
            </tbody>
          </table>
        </div>
        {/* 버튼 */}
        <div style={{position:"relative",width:"100%",marginTop:"10px"}}>
          <Link to={'/Admin/CourseList'} className="btn line" style={{width:"100px",position:"absolute",left:"0px"}}>목록</Link>
        </div>
      </div>
      <PopupChildrenStudy varOpenChildrenStudy={varOpenChildrenStudy} varChildrenInfo={varChildrenInfo} CloseChildrenStudy={CloseChildrenStudy}/>
    </div>
  );
}
export  default CourseDetail;